var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h2',[_vm._v("Logs")]),(_vm.webhooks)?_c('div',[_c('b',[_vm._v("Webhooks")]),_vm._v(" "),_c('itable',{attrs:{"tabledata":_vm.$store.state.items.webhooks}})],1):_vm._e(),(_vm.email)?_c('div',[_c('b',[_vm._v("Emails")]),_vm._v(" "),_c('itable',{attrs:{"tabledata":_vm.$store.state.items.email}})],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }